<template>
  <div>
    <div class="p-2">
      <ve-table :columns="columns" :table-data="tableData" />
    </div>
  </div>
</template>

<script>
export default {
  name: "AgreedCompetence",
  data() {
    return {
      columns: [
        {
          field: "Competency",
          key: "a",
          title: "Objective Name",
        },
        { field: "DueDate", key: "b", title: "Due Date" },
        {
          field: "Attachment",
          key: "c",
          title: "Attachment",
          renderBodyCell: () => {
            return <p class="cursor-pointer font-bold">&#128206;</p>;
          },
        },
        { field: "EmployeeReview", key: "ddd", title: "Employee Review" },
        { field: "MyReview", key: "d", title: "MyReview" },
        {
          field: "Agreed",
          key: "g",
          title: "Agreed",
        },
        { field: "Feedback", key: "e", title: "Feedback" },
      ],
      tableData: [
        {
          Competency: "Agility",
          DueDate: "15 Dec 2022",
          Attachment: "",
          EmployeeReview: "50%",
          MyReview: "98%",
          Agreed: "100%",
          Feedback: "",
        },
      ],
    };
  },
};
</script>
